import { generateLanguageQuery } from '@/services/dataStore/queries/fragments'

// TEMPORARY!!! Comment categories reuse the icon library originally created for observations, so the Sanity document type is still named `observationIcon`.
export const commentCategoryIconsQuery = () =>
  `*[_type == "observationIcon"] {
    _id,
    'altText': ${generateLanguageQuery('altText')},
    'imageURL': imageFile.asset->url,
    'keywords': ${generateLanguageQuery('keywords')}
  }`
